import * as React from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { isAuthenticated } from '../../data/providers/userProvider';
import { ConnectionStatusWrapper } from '../pages/login/components/ConnectionStatusWrapper';
import { Landing } from '../pages/login/Landing';

interface IProps {
  component: React.ReactNode;
}

const LoginLayout = ({ component: Component, ...rest }): React.ReactElement => (
  <Route
    {...rest}
    render={(props: RouteComponentProps): React.ReactElement =>
      !isAuthenticated() ? (
        <ConnectionStatusWrapper>
          <Landing {...props}>
            <Component />
          </Landing>
        </ConnectionStatusWrapper>
      ) : (
        <Redirect
          to={{
            pathname: '/teams',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

export { LoginLayout };
